import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
const MEDICAL_AIDS = [{
  name: 'Pula Medical Aid',
  logo: 'https://cdn.magicpatterns.com/uploads/qEh4t4eYguH2n4CHow7ckq/pulamed.png'
}, {
  name: 'Botsogo Health Plan',
  logo: 'https://cdn.magicpatterns.com/uploads/9pLKR9ja9F4vGJGQM9EAvj/botsogo_aid.jpg'
}, {
  name: 'BPOMAS',
  logo: 'https://cdn.magicpatterns.com/uploads/nsU7JXBEba7XwZtcJ9Lsxr/bpomas.png'
}, {
  name: 'BOMAID',
  logo: 'https://cdn.magicpatterns.com/uploads/mDMg7iJoS2XLGmTN1bFMqk/bomaid.png'
}];
export function MedicalAids() {
  return <section className="py-24 bg-white" data-id="element-163" data-mp="3rask286ivfo3">
      <div className="max-w-brand mx-auto px-4 sm:px-6 lg:px-8" data-id="element-164" data-mp="3n8nsdezmwt43">
        <div className="text-center max-w-2xl mx-auto mb-14" data-id="element-165" data-mp="3naigt3a473cx">
          <span className="inline-flex items-center gap-2 text-brand-gold font-semibold tracking-wider text-sm uppercase mb-3" data-id="element-166" data-mp="3i8jcnr6jw2ex">
            <ShieldCheck className="w-4 h-4" data-id="element-167" data-mp="3db9r4mma8awd" />
            Medical Aids Accepted
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-navy mb-4" data-id="element-168" data-mp="2dr385t8d2om8">
            We Work With Your Medical Aid
          </h2>
          <p className="text-slate-600 text-lg" data-id="element-169" data-mp="24s81yh5bheix">
            Maisha Medical Center accepts most major medical aid schemes in
            Botswana, making quality healthcare accessible and affordable for
            you and your family.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-170" data-mp="2xej3pv4ntlhb">
          {MEDICAL_AIDS.map(aid => <div key={aid.name} className="bg-white border border-slate-100 rounded-2xl shadow-sm hover:shadow-soft transition-all duration-300 flex items-center justify-center p-8 h-40 group" data-id="element-171" data-mp="31fwb49nehwqc">
              <img src={aid.logo} alt={`${aid.name} logo`} className="max-h-20 max-w-full object-contain grayscale opacity-80 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300" data-id="element-172" data-mp="1c2rfs18aitv5" />
            </div>)}
        </div>

        <p className="text-center text-sm text-slate-500 mt-10" data-id="element-173" data-mp="syfnz0tfldq9">
          Don't see your medical aid?{' '}
          <Link to="/contact" className="text-brand-red font-medium hover:underline" data-id="element-174" data-mp="o6xmmbnhxb4r">
            Contact us
          </Link>{' '}
          to confirm coverage before your visit.
        </p>
      </div>
    </section>;
}